module.exports = __webpack_public_path__ + "static/media/triller.e4ea3c72.png";